import { PeopleMerchantDto } from "../people-merchant.dto";
import { PeopleEmployeeDto } from "./people-employee.dto";

export class PeopleEmployeeClockInOutDto {
    id?: number;
    employeeId?: number;
    merchantId?: number;
    userId?: number;
    clockIn?: string;
    clockOut?: string;
    shiftDuration?: number;
    latitudeIn?: number;
    longitudeIn?: number;
    latitudeOut?: number;
    longitudeOut?: number;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
    merchant?: PeopleMerchantDto;
}